<template>
  <div>
    <el-input
      v-if="editMode && type === 'input'"
      v-model="localValue"
      size="medium"
      @input="onInput"
      show-word-limit
      :maxlength="maxLength"
    />
    <el-input
      v-else-if="editMode && type === 'textarea'"
      v-model="localValue"
      type="textarea"
      :rows="2"
      :autosize="false"
      @input="onInput"
      show-word-limit
      :maxlength="maxLength"
    />
    <el-select
      v-else-if="editMode && type === 'select'"
      v-model="localValue"
      size="mini"
      @change="onInput"
    >
      <el-option
        v-for="opt in options"
        :key="opt.value"
        :label="opt.label"
        :value="opt.value"
      />
    </el-select>
    <span v-else>{{ displayText }}</span>
  </div>
</template>
<script>
import { defineComponent, ref, watch, computed } from '@vue/composition-api';

const EMITS = {
  INPUT: 'input',
};

export default defineComponent({
  name: 'TwTableCell',
  props: {
    value: [String, Number],
    editMode: Boolean,
    type: {
      type: String,
      default: 'input',
    },
    options: {
      type: Array,
      default: () => [],
    },
    rules: {
      type: Array,
      default: () => [],
    },
    maxLength: {
      type: Number,
      default: undefined,
    }
  },
  setup(props, { emit }) {
    const localValue = ref(props.value);

    watch(
      () => props.value,
      (val) => {
        localValue.value = val;
      },
    );
    const displayText = computed(() => {
      if (props.type === 'select') {
        const match = props.options.find((opt) => opt.value === props.value);
        return match ? match.label : props.value;
      }
      return props.value;
    });
    const onInput = (val) => {
      emit(EMITS.INPUT, val);
    };

    return {
      localValue,
      displayText,
      onInput,
    };
  },
});
</script>

<style scoped>
::v-deep .el-table .cell {
  line-height: 1.5;
}
::v-deep .el-textarea__inner {
  font-size: 11px;
}
</style>
